import { Type } from 'class-transformer'
import { AuditMetadata } from './auditMetadata.model'
import {
  ChangeRequestStatus,
  changeRequestStatuses,
  changeRequestStatusLabels,
  ChangeRequestStatusName,
} from './change-request-statuses'
import { ChangeItem } from '@app/features/scope-overview/change-request/model'

export class ChangeRequest {
  id!: number
  name!: string
  description!: string
  originalScopeVersionId!: number
  mergedVersionOfScope!: number
  changes!: ChangeItem[]
  status!: ChangeRequestStatus
  archived!: boolean
  localId?: number
  @Type(() => AuditMetadata) auditMetadata!: AuditMetadata

  getStatusText(): string {
    const statusText = this.status ? this.status.toString().replace(/_/g, ' ') : ''
    return statusText.charAt(0).toUpperCase() + statusText.toLowerCase().slice(1)
  }

  getChangeRequestId(): string {
    if (!this.id) return ''
    return `CR-${String(this.id).padStart(3, '0')}`
  }
}

export { ChangeRequestStatus, changeRequestStatuses, changeRequestStatusLabels, ChangeRequestStatusName }
